import React, { useEffect, useState, useRef } from 'react';
import ls from 'local-storage';
import {
  CAvatar,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow
} from '@coreui/react';
import { CChartBar, CChartLine } from '@coreui/react-chartjs';
import Moment from 'moment';
import { DateRangePicker } from 'react-date-range';
import { format, isWeekend } from 'date-fns';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  todayRevenue,
  getSalesTrend,
  getDailyTrend,
  reportPerDay,
} from 'src/services/BranchAnalytics';
import formatter from 'src/reusables/formatter';
import { colors } from 'src/reusables/const';

function BranchAnalytics() {
  const location = useLocation();

  const useWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    const comparison = width / height;
    const [windowDimensions, setWindowDimensions] = useState({
      width,
      height,
      comparison
    });

    useEffect(() => {
      function handleResize() {
        const { innerWidth: width, innerHeight: height } = window;
        const comparison = width / height;
        setWindowDimensions({ width, height, comparison });
      }

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
  };

  const { height, width, comparison } = useWindowDimensions();

  function applyResponsive(small, height){
    return comparison < 1 ? small : height
  }

  const [drModal, setDrModal] = useState(false);
  // const [summaryModal,setSummaryModal] = useState(false)
  const [refetch, setRefetch] = useState(false);
  const [renderCounter, setRenderCounter] = useState(0);
  const [todayRevLabel, setTodayRevLabel] = useState([]);
  const [todayRev, setTodayRev] = useState([]);
  const [yesterdayRevLabel, setYesterdayRevLabel] = useState([]);
  const [yesterdayRev, setYesterdayRev] = useState([]);
  const [todayCountLabel, setTodayCountLabel] = useState([]);
  const [todayCount, setTodayCount] = useState([]);
  const [yesterdayCountLabel, setYesterdayCountLabel] = useState([]);
  const [yesterdayCount, setYesterdayCount] = useState([]);
  const [salesTrendLabel, setSalesTrendLabel] = useState([]);
  const [salesTrendLabelRev, setSalesTrendLabelRev] = useState([]);
  const [salesTrendValue, setSalesTrendValue] = useState([]);
  const [salesTrendCount, setSalesTrendCount] = useState([]);

  const [todayHHRev, setTodayHHRev] = useState([])
  const [todayHHCount, setTodayHHCount] = useState([])
  const [todayDiscountRev, setTodayDiscountRev] = useState([])
  const [todayDiscountCount, setTodayDiscountCount] = useState([])
  const [todayTimeoutRev, setTodayTimeoutRev] = useState([])
  const [todayTimeoutCount, setTodayTimeoutCount] = useState([])
  const [todayReprintCount, setTodayReprintCount] = useState([])
  const [todayReprintRevenue, setTodayReprintRevenue] = useState([])

  const [yesterdayHHRev, setYesterdayHHRev] = useState([])
  const [yesterdayHHCount, setYesterdayHHCount] = useState([])
  const [yesterdayDiscountRev, setYesterdayDiscountRev] = useState([])
  const [yesterdayDiscountCount, setYesterdayDiscountCount] = useState([])
  const [yesterdayTimeoutRev, setYesterdayTimeoutRev] = useState([])
  const [yesterdayTimeoutCount, setYesterdayTimeoutCount] = useState([])

  const [salesTrendHHRev, setSalesTrendHHRev] = useState([])
  const [salesTrendHHCount, setSalesTrendHHCount] = useState([])
  const [salesTrendDiscountRev, setSalesTrendDiscountRev] = useState([])
  const [salesTrendDiscountCount, setSalesTrendDiscountCount] = useState([])
  const [salesTrendTimeoutRev, setSalesTrendTimeoutRev] = useState([])
  const [salesTrendTimeoutCount, setSalesTrendTimeoutCount] = useState([])
  const [salesTrendReprintRevenue, setSalesTrendReprintRevenue] = useState([])
  const [salesTrendReprintCount, setSalesTrendReprintCount] = useState([])

  const [discountCountDailyTrend, setDiscountCountDailyTrend] = useState([]);
  const [discountDailyTrend, setDiscountDailyTrend] = useState([]);

  const [chartLineLabelHour, setChartLineLabelHour] = useState([]);
  const [chartLineDataHour, setChartLineDataHour] = useState([]);
  const [chartLineLabelDay, setChartLineLabelDay] = useState([]);
  const [chartLineDataDay, setChartLineDataDay] = useState([]);

  const endDay = Moment(new Date()).format('YYYY-MM-DD');
  const max = new Date(endDay);

  const [currentPerHour, setCurrentPerHour] = useState("Revenue")
  const [currentPropsPerHour, setCurrentPropsPerHour] = useState("grand_total")
  const [currentPerDay, setCurrentPerDay] = useState("Revenue")
  const [currentPropsPerDay, setCurrentPropsPerDay] = useState("grand_total")

  const LIST_OF_VARIABLES = [
    {
      name: "Revenue",
      props : "grand_total"
    },
    {
      name: "Trx Count",
      props : "printCount"
    },
    {
      name: "Total Discount",
      props : "discount"
    },
    {
      name: "Voucher Usage",
      props : "discount_count"
    },
    {
      name: "Total Happy Hour",
      props : "total_hh"
    },
    {
      name: "Happy Hour Count",
      props : "count_hh"
    },
    {
      name: "Reprint Revenue",
      props : "reprint_revenue"
    },
    {
      name: "Reprint Count",
      props : "reprint_count"
    },
  ] 

  const navigate = useNavigate();

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(`${Moment(new Date()).startOf('month')}`),
      endDate: new Date()
    }
  ]);
  async function fetchTodayRevenue(id) {
    await todayRevenue().then((response) => {
      const yesterdayNameLabel = response.yesterdayData.map((item, i) => {
        return item.name;
      });
      setYesterdayRevLabel(yesterdayNameLabel);
      const nameLabel = response.todayData.map((item, i) => {
        return item.name;
      });
      setTodayRevLabel(nameLabel);
      const rev = response.todayData.map((item, i) => {
        return item.revenue;
      });
      setTodayRev(rev);
      const yesterdayRev = response.yesterdayData.map((item, i) => {
        return item.revenue;
      });
      setYesterdayRev(yesterdayRev);


      const revHH = response.todayData.map((item, i) => {
        return item.total_hh;
      });
      setTodayHHRev(revHH);
      const yesterdayRevHH = response.yesterdayData.map((item, i) => {
        return item.total_hh;
      });
      setYesterdayHHRev(yesterdayRevHH)

      const countHH = response.todayData.map((item, i) => {
        return item.count_hh;
      });
      setTodayHHCount(countHH);
      const yesterdayCountHH = response.yesterdayData.map((item, i) => {
        return item.count_hh;
      });
      setYesterdayHHCount(yesterdayCountHH)

      const discountRev = response.todayData.map((item, i) => {
        return item.total_discount;
      });
      setTodayDiscountRev(discountRev);
      const yesterdayDiscountRev = response.yesterdayData.map((item, i) => {
        return item.total_discount;
      });
      setYesterdayDiscountRev(yesterdayDiscountRev)

      const discountCount = response.todayData.map((item, i) => {
        return item.count_voucher;
      });
      setTodayDiscountCount(discountCount);
      
      const yesterdayDiscountCount = response.yesterdayData.map((item, i) => {
        return item.count_voucher;
      });
      setYesterdayDiscountCount(yesterdayDiscountCount)

      const timeoutRev = response.todayData.map((item, i) => {
        return item.timeout_collected;  
      });
      setTodayTimeoutRev(timeoutRev);
      const yesterdaytimeoutRev = response.yesterdayData.map((item, i) => {
        return item.timeout_collected;
      });
      setYesterdayTimeoutRev(yesterdaytimeoutRev)

      const timeoutCount = response.todayData.map((item, i) => {
        return item.count_timeout;
      });
      setTodayTimeoutCount(timeoutCount);
      const yesterdaytimeoutCount = response.yesterdayData.map((item, i) => {
        return item.count_timeout;
      });
      setYesterdayTimeoutCount(yesterdaytimeoutCount)

      const countLabel = response.todayData.map((item, i) => {
        return item.name;
      });      
      setTodayCountLabel(countLabel);
      const count = response.todayData.map((item, i) => {
        return item.printCount;
      });
      setTodayCount(count);

      const reprintCount = response.todayData.map((item, i) => {
        return item.reprint_count;
      });
      setTodayReprintCount(reprintCount);

      const reprintRev = response.todayData.map((item, i) => {
        return item.reprint_revenue;
      });
      setTodayReprintRevenue(reprintRev);

      const yesterdayCountLabel = response.todayData.map((item, i) => {
        return item.name;
      });      
      setYesterdayCountLabel(yesterdayCountLabel);
      const yesterdayCount = response.todayData.map((item, i) => {
        return item.printCount;
      });
      setYesterdayCount(yesterdayCount);
    });
  }

  async function fetchSalesTrend(dateFrom, dateTo, id) {
    await getSalesTrend(dateFrom, dateTo, id ?? '').then((response) => {
      const label = response.mappedSalesTrend.map((item, i) => {
        return item.merchantName;
      });
      setSalesTrendLabel(label);

      const labelRevenue = response.mappedSalesTrend
        .filter((item, i) => item.grand_total > 0)
        .map((item, i) => {
          return item.merchantName;
        });
      setSalesTrendLabelRev(labelRevenue);

      const grand_total = response.mappedSalesTrend
        .filter((item, i) => item.grand_total > 0)
        .map((item, i) => {
          return item.grand_total;
        });
      setSalesTrendValue(grand_total);

      const printCount = response.mappedSalesTrend.map((item, i) => {
        return item.printCount;
      });
      setSalesTrendCount(printCount);

      const discountCount = response.mappedSalesTrend.map((item, i) => {
        return item.discount_count;
      });
      setDiscountCountDailyTrend(discountCount);

      const discountValue = response.mappedSalesTrend.map((item, i) => {
        return item.discount;
      });
      setDiscountDailyTrend(discountValue);

      const isHappyHour = response.mappedSalesTrend.map((item, i) => {
        return item.is_happy_hour;
      });
      setSalesTrendHHCount(isHappyHour)
      
      const totalHappyHour = response.mappedSalesTrend.map((item, i) => {
        return item.total_hh;
      });
      setSalesTrendHHRev(totalHappyHour)

      const voucherCount = response.mappedSalesTrend.map((item, i) => {
        return item.count_voucher;
      });
      setSalesTrendDiscountCount(voucherCount)

      const timeoutCount = response.mappedSalesTrend.map((item, i) => {
        return item.count_timeout;
      });
      setSalesTrendTimeoutCount(timeoutCount)

      const timeoutRev = response.mappedSalesTrend.map((item, i) => {
        return item.timeout_collected;
      });
      setSalesTrendTimeoutRev(timeoutRev)

      const reprintRev = response.mappedSalesTrend.map((item, i) => {
        return item.reprint_revenue;
      });
      setSalesTrendReprintRevenue(reprintRev)

      const reprintCount = response.mappedSalesTrend.map((item, i) => {
        return item.reprint_count;
      });
      setSalesTrendReprintCount(reprintCount)
    });
  }

  function mapAndSortForChartHour(param){
    return chartLineDataHour.sort((a,b) => b.reduce((carry, item) => { return carry + item[param] }, 0)  - a.reduce((carry, item) => { return carry + item[param] }, 0)).map((item, i) => {
      return {
        label: item[0].name,
        backgroundColor: item[0].color,
        borderColor: item[0].color,
        data: item.map((perHour) => perHour[param]),
        borderWidth: applyResponsive(1,3),
        pointBorderWidth: applyResponsive(0.4,1),
        pointRadius: applyResponsive(0.8,3),
        pointHoverBorderWidth: applyResponsive(0.5,1),
        stack: `Stack ${i}`
      }
    })
  }

  function mapAndSortForChartDay(param){
    return chartLineDataDay.sort((a,b) => b.reduce((carry, item) => { return carry + item[param] }, 0)  - a.reduce((carry, item) => { return carry + item[param] }, 0)).map((item, i) => {
      return {
        label: item[0].name,
        backgroundColor: item[0].color,
        borderColor: item[0].color,
        borderWidth: applyResponsive(1,3),
        pointBorderWidth: applyResponsive(0.4,1),
        pointRadius: applyResponsive(0.8,3),
        pointHoverBorderWidth: applyResponsive(0.5,1),
        data: item.map((perDay) => perDay[param]),
        stack: `Stack ${i}`
      }
    })
  }

  async function fetchDailyTrend(dateFrom, dateTo, id){
    const response = await getDailyTrend(dateFrom, dateTo, id ?? '')

    if(parseInt(response.success) === 1){

      const sortedList = response.dailyTrend.sort((a,b) => a.hourRef.localeCompare(b.hourRef) )

      const label = sortedList.reduce((carry, item) => {

        let dataCarry = [...carry]

        if(JSON.stringify(carry) === JSON.stringify([])){
          dataCarry.push(item.hourRef)
        } else if(carry.some((data) => data === item.hourRef) === false){
          dataCarry.push(item.hourRef)
        }

        return dataCarry;
      },[]);

      setChartLineLabelHour(label);

      const reducer = sortedList.reduce((carry, item, i) => {

        //name variable so it can be used in bracket notation
        let itemName = item.name
        
        if(itemName === "Alfa"){
          return carry
        }

        //destructure for data structure empty object (object for hour that are having no records)
        var emptyObjects = {...item}

        // if carry does not have the itemName property
        if(carry[itemName] === undefined){

          //initializing empty array
          carry[itemName] = []

          //making data structure for empty obhect
          for(var key in emptyObjects){
            if(key !== "hourRef" && key !== "name" && key !== "booth_id"){
              emptyObjects[key] = 0
            }
          }

          emptyObjects["color"] = colors[Object.values(carry).length ?? 0]

          //forEach to push data to carry[itemName] of empty hour object (all data in carry[itemName] to have empty hour object first)
          label.forEach((lab) => {

            //destructure to break the pointer to emptyObject variable so the data inside the object can be edited
            let localObject = {...emptyObjects}
            
            //adjusting hourRef to designated hour
            localObject.hourRef = lab

            //push emptyObject to carry[itemName]
            carry[itemName].push(localObject)

          })

        }

        //filter all the emptyObject data of carry[itemName] to be not included in the array 
        let validateCarry = carry[itemName].filter((data) => data.hourRef !== item.hourRef)
        
        //inserting data
        validateCarry.push({...item, color: colors[Object.values(carry).length ?? 0]})

        // sort data so the pushed data in order of hourRef
        let returnedItemCarry = validateCarry.sort((a,b) => a.hourRef.localeCompare(b.hourRef))

        // giving back array to carry[itemName]
        carry[itemName] = returnedItemCarry

        // returning carry[itemName]
        return carry

      }, {})

      setChartLineDataHour(Object.values(reducer))

    } 

  }

  async function fetchReportPerDay(dateFrom, dateTo, id){
    const response = await reportPerDay(dateFrom, dateTo, id ?? '')

    if(parseInt(response.success) === 1){

      const sortedList = response.dailyTrend.sort((a,b) => a.dateRef.localeCompare(b.dateRef) )

      const label = sortedList.reduce((carry, item) => {

        let dataCarry = [...carry]

        if(JSON.stringify(carry) === JSON.stringify([])){
          dataCarry.push(item.dateRef)
        } else if(carry.some((data) => data === item.dateRef) === false){
          dataCarry.push(item.dateRef)
        }

        return dataCarry;
      },[]);

      setChartLineLabelDay(label);

      // console.log({label})

      const reducer = sortedList.reduce((carry, item, i) => {

        //name variable so it can be used in bracket notation
        let itemName = item.name
        
        if(itemName === "Alfa"){
          return carry
        }

        //destructure for data structure empty object (object for hour that are having no records)
        var emptyObjects = {...item}

        // if carry does not have the itemName property
        if(carry[itemName] === undefined){

          //initializing empty array
          carry[itemName] = []

          //making data structure for empty obhect
          for(var key in emptyObjects){
            if(key !== "dateRef" && key !== "name" && key !== "booth_id"){
              emptyObjects[key] = 0
            }
          }

          emptyObjects["color"] = colors[Object.values(carry).length ?? 0]

          //forEach to push data to carry[itemName] of empty hour object (all data in carry[itemName] to have empty hour object first)
          label.forEach((lab) => {

            //destructure to break the pointer to emptyObject variable so the data inside the object can be edited
            let localObject = {...emptyObjects}
            
            //adjusting dateRef to designated hour
            localObject.dateRef = lab

            //push emptyObject to carry[itemName]
            carry[itemName].push(localObject)

          })

        }

        //filter all the emptyObject data of carry[itemName] to be not included in the array 
        let validateCarry = carry[itemName].filter((data) => data.dateRef !== item.dateRef)
        
        //inserting data
        validateCarry.push({...item, color: colors[Object.values(carry).length ?? 0]})

        // sort data so the pushed data in order of dateRef
        let returnedItemCarry = validateCarry.sort((a,b) => a.dateRef.localeCompare(b.dateRef))

        // giving back array to carry[itemName]
        carry[itemName] = returnedItemCarry

        // returning carry[itemName]
        return carry

      }, {})

      setChartLineDataDay(Object.values(reducer))

    } 

  }

  const BAR_CHART_OPTIONS = {
    scales:{
      x: {
        stacked : true,
        ticks: {
          font: {
            size: applyResponsive(7,12)
          }
        }
      },
      y: {
        ticks: {
          font: {
            size: applyResponsive(7,12)
          }
        }
      }
    },
    responsive: true,
    maintainAspectRatio: applyResponsive(0, 1),
    interaction: {
      intersect: false
    },
    font: {
      size: applyResponsive(7,12)
    },
    plugins:{
      legend:{
        labels: {
          font: {
            size: applyResponsive(7,12),
          },
          boxWidth: applyResponsive(12,24)
        }
      }
    }
  }

  const LINE_CHART_OPTIONS = {
    responsive: true,
    maintainAspectRatio: applyResponsive(false, true),
    interaction: {
      mode: 'index',
      intersect: false,
    },
    font: {
      size: applyResponsive(7,12)
    },
    stacked: true,
    plugins: {
      legend:{
        labels: {
          font: {
            size: applyResponsive(7,12),
          },
          boxWidth: applyResponsive(12,24),
          boxHeight: applyResponsive(4,12),
          padding: applyResponsive(4,12)
        }
      },
      title: {
        display: true,
        text: `${currentPerHour} Per Booth`,
        font: {
          size: applyResponsive(7,12)
        }
      },
    },
    scales: {
      y: {
        type: 'linear',
        display: true,
        position: 'left',
        ticks: {
          font: {
            size: applyResponsive(7,12)
          }
        }
      },
      x: {
        ticks: {
          font: {
            size: applyResponsive(7,12)
          }
        }
      }
    }
  }

  function buttonGroupStyling(item, current) {
    return { backgroundColor: item.name === current ? '#2441c2' : '#4E5B97', border: 'none', marginRight:"1vw", marginBottom:"1vw", width:applyResponsive(`${100/6}vw`,"default"), height:applyResponsive("3.4vh","default"), fontSize:applyResponsive(7, "default") }
  }


  useEffect(() => {
    if (ls.get('userDetail')) {
      if (ls.get('userDetail').org_id === 0 && location.state === 'login success' && renderCounter === 0) {
        window.history.replaceState({}, document.title);
        navigate(0);
      } else {
        const newStartDay = formatter('SQLDate', dateRange[0].startDate);
        const newEndDay = formatter('SQLDate', dateRange[0].endDate);
        if ((refetch && renderCounter > 0) || renderCounter === 0) {
          fetchTodayRevenue();
          fetchSalesTrend(newStartDay, newEndDay);
          fetchDailyTrend(newStartDay, newEndDay);
          // fetchMostUsedFrames(newStartDay, newEndDay);
          fetchReportPerDay(newStartDay, newEndDay);
          // fetchMostUsedCategoryFrames(newStartDay, newEndDay);
          setRefetch(false);
        }
        setRenderCounter(renderCounter + 1);
      }
    } else {
      navigate('/login');
    }
  }, [dateRange, refetch, drModal]);

  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: '5px',
            width: '5px',
            borderRadius: '100%',
            background: 'orange',
            position: 'absolute',
            top: 2,
            right: 2
          }}
        />
      );
    }
    return (
      <div>
        <span
          style={{
            fontWeight: '600'
          }}
        >
          {format(day, 'd')}
        </span>
      </div>
    );
  }

  function changeCurrentStateHour(prop){
    setCurrentPerHour(prev => LIST_OF_VARIABLES.filter((item) => item.props === prop)[0].name)
    setCurrentPropsPerHour(prop)
  }

  function changeCurrentStateDay(prop){
    setCurrentPerDay(prev => LIST_OF_VARIABLES.filter((item) => item.props === prop)[0].name)
    setCurrentPropsPerDay(prop)
  }


  return (
    <div style={{ color: 'black' }}>
      <CCol xs={12}>
        <CCard className="mb-4" style={{ maxHeight: applyResponsive('80vh','60vh') }}>
          <CCardHeader>Today's Revenue</CCardHeader>
          <CCardBody>
            <CChartBar
              style={{ marginBottom: applyResponsive('0vh','3vh'), maxHeight: '40vh', height:'40vh' }}
              data={{
                labels: todayRevLabel,
                datasets: [
                  {
                    label: 'Revenue',
                    backgroundColor: '#4E5B97',
                    data: todayRev,
                    stack: 'Stack 0'
                  },
                  {
                    label: 'Happy Hour Revenue',
                    backgroundColor: '#138D5E',
                    data: todayHHRev, 
                    stack: 'Stack 1'
                  },
                  {
                    label: 'Discount Revenue',
                    backgroundColor: '#F3AA1C',
                    data: todayDiscountRev, 
                    stack: 'Stack 2'
                  },
                  {
                    label: 'Timeout Revenue',
                    backgroundColor: '#e35535',
                    data: todayTimeoutRev, 
                    stack: 'Stack 3'
                  },
                  {
                    label: 'Reprint Revenue',
                    backgroundColor: '#74DE10',
                    data: todayReprintRevenue, 
                    stack: 'Stack 4'
                  },
                ]
              }}
              options={BAR_CHART_OPTIONS}
              labels="months"
            />
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs={12}>
        <CCard className="mb-4" style={{ maxHeight: applyResponsive('80vh','60vh')}}>
          <CCardHeader>Today's Trx Count</CCardHeader>
          <CCardBody>
            <CChartBar
              style={{ marginBottom: applyResponsive('0vh','3vh'), maxHeight: '40vh', height:'40vh' }}
              data={{
                labels: todayCountLabel,
                datasets:[
                  {
                    label: 'Trx Count',
                    backgroundColor: '#4E5B97',
                    data: todayCount,
                    stack: 'Stack 0'
                  },
                  {
                    label: 'Happy Hour Count',
                    backgroundColor: '#138D5E',
                    data: todayHHCount,
                    stack: 'Stack 1'
                  },
                  {
                    label: 'Discount Count',
                    backgroundColor: '#F3AA1C',
                    data: todayDiscountCount, 
                    stack: 'Stack 2'
                  },
                  {
                    label: 'Timeout Count',
                    backgroundColor: '#e35535',
                    data: todayTimeoutCount, 
                    stack: 'Stack 3'
                  },
                  {
                    label: 'Reprint Count',
                    backgroundColor: '#74DE10',
                    data: todayReprintCount, 
                    stack: 'Stack 4'
                  },
                ]
              }}
              options={BAR_CHART_OPTIONS}
              labels="months"
            />
          </CCardBody>
        </CCard>
      </CCol>
      {/* <CCol xs={12}>
        <CCard className="mb-4" style={{ maxHeight: applyResponsive('80vh','60vh') }}>
          <CCardHeader>Yesterday's Revenue</CCardHeader>
          <CCardBody>
            <CChartBar
              style={{ marginBottom: applyResponsive('0vh','3vh'), maxHeight: '40vh' }}
              data={{
                labels: yesterdayRevLabel,
                datasets: [
                  {
                    label: 'Revenue',
                    backgroundColor: '#4E5B97',
                    data: yesterdayRev,
                    stack: 'Stack 0'
                  },
                  {
                    label: 'Happy Hour Revenue',
                    backgroundColor: '#138D5E',
                    data: yesterdayHHRev, 
                    stack: 'Stack 1'
                  },
                  {
                    label: 'Discount Revenue',
                    backgroundColor: '#F3AA1C',
                    data: yesterdayDiscountRev, 
                    stack: 'Stack 2'
                  },
                  {
                    label: 'Timeout Revenue',
                    backgroundColor: '#e35535',
                    data: yesterdayTimeoutRev, 
                    stack: 'Stack 3'
                  },
                ]
              }}
              options={BAR_CHART_OPTIONS}
              labels="months"
            />
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs={12}>
        <CCard className="mb-4" style={{ maxHeight: applyResponsive('80vh','60vh') }}>
          <CCardHeader>Yesterday's Trx Count</CCardHeader>
          <CCardBody>
            <CChartBar
              style={{ marginBottom: applyResponsive('0vh','3vh'), maxHeight: '40vh' }}
              data={{
                labels: todayCountLabel,
                datasets: [
                  {
                    label: 'Trx Count',
                    backgroundColor: '#4E5B97',
                    data: todayCount,
                    stack: 'Stack 0'
                  },
                  {
                    label: 'Happy Hour Count',
                    backgroundColor: '#138D5E',
                    data: todayHHCount,
                    stack: 'Stack 1'
                  },
                  {
                    label: 'Discount Count',
                    backgroundColor: '#F3AA1C',
                    data: todayDiscountCount, 
                    stack: 'Stack 2'
                  },
                  {
                    label: 'Timeout Count',
                    backgroundColor: '#e35535',
                    data: todayTimeoutCount, 
                    stack: 'Stack 3'
                  }
                ]
              }}
              options={BAR_CHART_OPTIONS}
              labels="months"
            />
          </CCardBody>
        </CCard>
      </CCol> */}
      <CRow style={{ overflow: 'scroll' }}>
        <CCol>
          <CButton
            className="ml-3 mb-3 btn btn-dark"
            style={{ backgroundColor: '#4E5B97', border: 'none'}}
            hover="true"
            onClick={() => {
              setDrModal(!drModal);
            }}
          >
            <div>
              {Moment(dateRange[0].startDate).format('ll')}
              {' - '}
              {Moment(dateRange[0].endDate).format('ll')}
            </div>
          </CButton>
        </CCol>
      </CRow>

      <CModal
        visible={drModal}
        style={{
          width: comparison < 1 ? '' : 'fit-content',
          overflowX: comparison < 1 ? 'scroll' : 'visible'
        }}
      >
        <CModalHeader
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CModalTitle>Date Range</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={(item) => {
                setDateRange([item.range1]);
                ls.set('dateRange', item.range1);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={dateRange}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
              dayContentRenderer={customDayContent}
            />
          </CCol>
        </CModalBody>
        <CModalFooter
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CButton style={{ backgroundColor: '#4E5B97', border: 'none' }} onClick={() => setDrModal(!drModal)}>
            Close
          </CButton>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => {
              setRefetch(true);
              setDrModal(false);
            }}
          >
            OK
          </CButton>
        </CModalFooter>
      </CModal>
      
      <CCol xs={12}>
        <CCard className="mb-4">
          <CCardHeader>Report for this Period</CCardHeader>
          <CCardBody style={{height:"auto"}}>
            <CChartBar
              style={{ marginBottom: applyResponsive('0vh','3vh'), maxHeight: applyResponsive('40vh','60vh'), height:applyResponsive('40vh','60vh') }}
              data={{
                labels: salesTrendLabelRev,
                datasets: [
                  {
                    label: 'By Revenue',
                    backgroundColor: '#4E5B97',
                    data: salesTrendValue,
                    stack: 'Stack 0'
                  },
                  {
                    label: 'By Discount Amount',
                    backgroundColor: '#F3AA1C',
                    data: discountDailyTrend,
                    stack: 'Stack 1'
                  },
                  {
                    label: 'By Happy Hour Amount',
                    backgroundColor: '#138D5E',
                    data: salesTrendHHRev,
                    stack: 'Stack 2'
                  },
                  {
                    label: 'By Timeout Revenue',
                    backgroundColor: '#E35535',
                    data: salesTrendTimeoutRev,
                    stack: 'Stack 3'
                  },
                  {
                    label: 'By Reprint Revenue',
                    backgroundColor: '#74DE10',
                    data: salesTrendReprintRevenue,
                    stack: 'Stack 4'
                  }
                ]
              }}
              options={BAR_CHART_OPTIONS}
              labels="months"
            />
            <CChartBar
              style={{ marginBottom: applyResponsive('0vh','3vh'),maxHeight: applyResponsive('40vh','60vh'), height:applyResponsive('40vh','60vh')}}
              data={{
                labels: salesTrendLabel,
                datasets: [
                  {
                    label: 'By Transaction',
                    backgroundColor: '#4E5B97',
                    data: salesTrendCount,
                    stack: 'Stack 0'
                  },
                  {
                    label: 'By Voucher Count',
                    backgroundColor: '#F3AA1C',
                    data: discountCountDailyTrend,
                    stack: 'Stack 1'
                  },
                  {
                    label: 'By Happy Hour Count',
                    backgroundColor: '#138D5E',
                    data: salesTrendHHCount,
                    stack: 'Stack 2'
                  },
                  {
                    label: 'By Timeout Count',
                    backgroundColor: '#E35535',
                    data: salesTrendTimeoutCount,
                    stack: 'Stack 3'
                  },
                  {
                    label: 'By Reprint Count',
                    backgroundColor: '#74DE10',
                    data: salesTrendReprintCount,
                    stack: 'Stack 4'
                  }
                ]
              }}
              options={BAR_CHART_OPTIONS}
              labels="months"
            />
          </CCardBody>
        </CCard>
      </CCol>
      
      <CCol xs={12}>
        <CCard className="mb-4">
          <CCardHeader>Report Per Day</CCardHeader>
            <CCardBody>

            <>
              {
                LIST_OF_VARIABLES.map((item) => {
                  return (
                    <CButton style={buttonGroupStyling(item, currentPerDay)}  onClick={(e) => {changeCurrentStateDay(item.props)}}>{item.name}</CButton>
                  )
                })
              }
            </>
            
            <CChartLine
              style={{marginBottom: applyResponsive('0vh','3vh'), height:applyResponsive("40vh", "inherit") }}
                data={{
                  labels: chartLineLabelDay,
                  datasets: mapAndSortForChartDay(currentPropsPerDay)
                }}
                options={LINE_CHART_OPTIONS}
                labels="months"
            />

            </CCardBody>
          </CCard>
      </CCol>

      <CCol xs={12}>
        <CCard className="mb-4">
          <CCardHeader>Report Per Hour</CCardHeader>
            <CCardBody>

              <>
                {
                  LIST_OF_VARIABLES.map((item) => {
                    return (
                      <CButton style={buttonGroupStyling(item, currentPerHour)} onClick={(e) => {changeCurrentStateHour(item.props)}}>{item.name}</CButton>
                    )
                  })
                }
              </>

              <CChartLine
                style={{ marginBottom: applyResponsive('0vh','3vh'), height:applyResponsive("40vh", "inherit") }}
                data={{
                  labels: chartLineLabelHour,
                  datasets: mapAndSortForChartHour(currentPropsPerHour)
                }}
                options={LINE_CHART_OPTIONS}
                labels="months"
              />

            </CCardBody>
        </CCard>
      </CCol>
    </div>
  );
}

export default BranchAnalytics;
